import React from "react";
import Button from "./Button";

function Card(props) {
	if (props.small) {
		const price = new Intl.NumberFormat("en-US", {
			style: "currency",
			currency: "USD",
		}).format(props.final_price);
		const body = {
			n_reports: props.n_reports,
			id: props.id,
			plan: props.name,
			pretty_price: price,
			price_id: props.priceId,
		};

		const backgroundsTitle = {
			1: "standard",
			2: "premium",
			3: "super",
			4: "power",
		};

		let benefitsList = [];
		benefitsList.push(
			<>
				<li className="text is-blue is-light-weight benefit include">
					<div>
						<i className="fa fa-check"></i>
						Equivalent to{" "}
						<strong className="include-cant">
							{props.final_price / props.n_reports}
						</strong>{" "}
						AUD per credit
					</div>
				</li>
				<hr />
			</>
		);

		const cardDetails = <ul className="benefits-list">{benefitsList}</ul>;
		const bgClassTitleStandalone = `is-${
			backgroundsTitle[props.pnum]
		}-plan`;
		const bgClassButtonStandalone = `is-button-${
			backgroundsTitle[props.pnum]
		}-plan`;

		return (
			<div className="card flexer-card">
				<div className={`${bgClassTitleStandalone} title-plan`}>
					<h4 className="subtitle is-white caps light-bold">
						{props.name}
					</h4>
				</div>
				<p className="subtitle price is-black caps line-margin-0">
					<strong>{props.final_price}</strong> AUD
				</p>
				<div className="includes-title">
					<hr />
					<h6>INCLUDES</h6>
				</div>
				<div className="container-benefits-standalone">
					{cardDetails}
				</div>
				<div
					className={`${bgClassButtonStandalone} container-button flexer-2`}
				>
					<div className="px-30 py-30">
						<Button
							type="button"
							class="full-width"
							text="Select"
							onClick={() => {
								props.onUpdate(body, 2);
							}}
						/>
					</div>
				</div>
			</div>
		);
	} else {
		// Card para planes de suscripción
		const formattedPrice = new Intl.NumberFormat("en-US", {
			style: "currency",
			currency: props.currency,
		}).format(props.price);
		const body = {
			plan: props.membershipName,
			id: props.id,
			nickname: props.name,
			description: props.description,
			price: props.price,
			price_id: props.priceId,
			currency: props.currency,
			pretty_price: formattedPrice,
			frequency: props.freq,
			type: "subscription",
		};

		let cardClass = "card flexer-card";
		let cardButton = (
			<Button
				type="button"
				class="full-width"
				onClick={() => {
					props.onUpdate(body, 2);
				}}
				text="Select"
			/>
		);

		let benefitsList = [];
		if (props.features && Array.isArray(props.features)) {
			benefitsList = props.features.map((benefit, index) => (
				<React.Fragment key={index}>
					<li className="text is-blue is-light-weight benefit include">
						<div>
							<i className="fa fa-check"></i> {benefit}
						</div>
					</li>
					<hr />
				</React.Fragment>
			));
		}

		const multiplyer = props.freq == 'year' ? 12 : 1
		const cardDetails = (
			<ul className="benefits-list">
				<li className="text is-blue is-light-weight benefit include">
					<div>
						<i className="fa fa-check"></i> {props.description}
					</div>
				</li>
				<hr />
				<li className="text is-blue is-light-weight benefit include">
					<div>
						<i className="fa fa-check"></i>
						Equivalent to{" "}
						<strong className="include-cant">
							{Math.round(props.price / (props.n_reports * multiplyer) * 100) / 100}
						</strong>{" "}
						AUD per credit
					</div>
				</li>
				<hr />
				{benefitsList}
			</ul>
		);
		if (props.type === "current") {
			cardClass = "card flexer-card plans-card-active";
			cardButton = <div className="current-button">Current Plan</div>;
		} else if (props.type === "downgrade") {
			cardClass = "card flexer-card plans-card-active";
			cardButton = null;
		} else if (props.type === "upgrade") {
			cardButton = (
				<Button
					type="button"
					class="full-width"
					text="Select"
					onClick={props.onUpdate}
				/>
			);
		}

		const basicName = props.membershipName.split(" ")[0].toLowerCase();
		const bgClassTitlePlan = `is-${basicName}-plan`;
		const bgClassButtonPlan = `is-button-${basicName}-plan`;

		return (
			<div className={cardClass}>
				<div className={`${bgClassTitlePlan} title-plan`}>
					<h4 className="subtitle is-white caps light-bold">
						{props.membershipName}
					</h4>
				</div>
				<div className="flexer-2 mx-30">
					<p className="subtitle price is-black caps line-margin-0">
						<strong>{props.price}</strong> AUD
					</p>
					<p className="subtext is-black line-margin-0">{`per ${props.freq} with discount`}</p>
					<div className="includes-title">
						<hr />
						<h6>INCLUDES</h6>
					</div>
					<div className="container-benefits">{cardDetails}</div>
				</div>
				<div
					className={`${bgClassButtonPlan} container-button flexer-2`}
				>
					<div className="px-30 py-30">{cardButton}</div>
				</div>
			</div>
		);
	}
}

export default Card;
